import { useNavigate } from "react-router";

import Helmet from "../../components/helmet.js";
import { Settings as SettingsIcon, FileEdit, UserPlus } from "../../../files/icons/index.js";

function Settings() {
  const navigate = useNavigate();

  function navigateTo(path) {
    navigate(path);
  }

  return (
    <>
      <Helmet title="Settings" />

      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-xs-12 col-lg-offset-2 col-lg-8">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <div className="typo-hero-small">Settings</div>
                <div className="typo-normal-175">Manage organization settings and configurations</div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-offset-2 col-lg-8">
            <div className="row">
              <div className="col-xs-12 col-lg-4 mb-3">
                <div className="card" style={{height: '100%'}}>
                  <div className="card-content sm">
                    <div className="d-flex align-items-center mb-3">
                      <div style={{width: '48px', height: '48px', borderRadius: '12px', backgroundColor: '#f0f4ff', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '12px'}}>
                        <SettingsIcon height={24} width={24} color={'#4a6cf7'} />
                      </div>
                      <div style={{flex: 1}}>
                        <div className="typo-strong-200">Organization</div>
                        <div className="typo-normal-125" style={{color: '#666'}}>Manage organization settings</div>
                      </div>
                    </div>
                    <div style={{borderTop: '1px solid #f0f0f0', paddingTop: '12px', marginTop: '12px'}}>
                      <div className="item typo-normal-150" onClick={() => navigateTo('/settings/general')} style={{padding: '8px 12px', borderRadius: '8px', transition: 'background-color 0.2s', cursor: 'pointer'}} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                        General Settings
                      </div>
                      <br/>
                      <div className="item typo-normal-150" onClick={() => navigateTo('/settings/users')} style={{padding: '8px 12px', borderRadius: '8px', transition: 'background-color 0.2s', cursor: 'pointer'}} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                        Users
                      </div>
                      <br/>
                      <div className="item typo-normal-150" onClick={() => navigateTo('/settings/respite-benefits')} style={{padding: '8px 12px', borderRadius: '8px', transition: 'background-color 0.2s', cursor: 'pointer'}} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                        Respite Annual Benefits
                      </div>
                      <br/>
                      <div className="item typo-normal-150" onClick={() => navigateTo('/settings/claim-settings')} style={{padding: '8px 12px', borderRadius: '8px', transition: 'background-color 0.2s', cursor: 'pointer'}} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                        Claim Settings
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xs-12 col-lg-4 mb-3">
                <div className="card" style={{height: '100%'}}>
                  <div className="card-content sm">
                    <div className="d-flex align-items-center mb-3">
                      <div style={{width: '48px', height: '48px', borderRadius: '12px', backgroundColor: '#fff4e6', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '12px'}}>
                        <FileEdit height={24} width={24} color={'#ff9800'} />
                      </div>
                      <div style={{flex: 1}}>
                        <div className="typo-strong-200">Templates</div>
                        <div className="typo-normal-125" style={{color: '#666'}}>Manage contact templates</div>
                      </div>
                    </div>
                    <div style={{borderTop: '1px solid #f0f0f0', paddingTop: '12px', marginTop: '12px'}}>
                      <div className="item typo-normal-150" onClick={() => navigateTo('/settings/templates/contacts')} style={{padding: '8px 12px', borderRadius: '8px', transition: 'background-color 0.2s', cursor: 'pointer'}} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                        Contact Templates
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xs-12 col-lg-4 mb-3">
                <div className="card" style={{height: '100%'}}>
                  <div className="card-content sm">
                    <div className="d-flex align-items-center mb-3">
                      <div style={{width: '48px', height: '48px', borderRadius: '12px', backgroundColor: '#e8f5e9', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '12px'}}>
                        <UserPlus height={24} width={24} color={'#4caf50'} />
                      </div>
                      <div style={{flex: 1}}>
                        <div className="typo-strong-200">Partners</div>
                        <div className="typo-normal-125" style={{color: '#666'}}>Manage partner organizations</div>
                      </div>
                    </div>
                    <div style={{borderTop: '1px solid #f0f0f0', paddingTop: '12px', marginTop: '12px'}}>
                      <div className="item typo-normal-150" onClick={() => navigateTo('/settings/partners')} style={{padding: '8px 12px', borderRadius: '8px', transition: 'background-color 0.2s', cursor: 'pointer'}} onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'} onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}>
                        Manage
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Settings;


